import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import styles from './ContentWithMedia.module.scss';
import cx from 'classnames';
import { Media } from '../lazyComponents';
import useBreakpoint from '../../lib/helpers/useBreakpoint';

const ContentWithMedia = (props) => {
    const currentBreakpoint = useBreakpoint();

    const {
        altText,
        children,
        videoLink,
        fileReference,
        mobilePosition,
        desktopPosition,
        graphicalElement,
        videoTranscription,
        showTranscription,
    } = props;

    const mediaElement = (
        <Suspense fallback={''}>
            <Media
                altText={altText}
                videoLink={videoLink}
                videoTranscription={videoTranscription}
                showTranscription={showTranscription}
                fileReference={fileReference}
                horizontalAlignment="stretch"
                graphicalElement={graphicalElement}
            />
        </Suspense>
    );

    const isDesktop = currentBreakpoint === 'desktop' || currentBreakpoint === 'desktop-l';

    const mediaFirst = isDesktop
        ? desktopPosition === 'media-left'
        : mobilePosition === 'media-above';

    return (
        <div className={cx(styles.root)}>
            {mediaFirst && (
                <div className={cx(styles['content--left'], styles['content--top'])}>
                    {mediaElement}
                </div>
            )}
            <div className={cx(styles.content)}>{children}</div>
            {!mediaFirst && (
                <div className={cx(styles['content--right'], styles['content--top'])}>
                    {mediaElement}
                </div>
            )}
        </div>
    );
};

ContentWithMedia.displayName = 'ContentWithMedia';

ContentWithMedia.propTypes = {
    altText: PropTypes.string,
    videoLink: PropTypes.string,
    fileReference: PropTypes.string,
    mobilePosition: PropTypes.string,
    desktopPosition: PropTypes.string,
    graphicalElement: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default ContentWithMedia;
